import {  useEffect, useState } from "react";
import { fetchHomePage } from "../../services/api";

export default function HowCanWeHelp({ lang = "en" }) {
  const [content, setContent] = useState(null);
  const [fallbackContent, setFallbackContent] = useState(null);

  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 1024);

const Base_URL = process.env.REACT_APP_Base_URL;
  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth > 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setContent(null);

    // Always fetch English as fallback
    fetchHomePage("en").then(setFallbackContent).catch(() => {});

    // Fetch current locale
    if (lang !== "en") {
      fetchHomePage(lang)
        .then((res) => {
          if (res) setContent(res);
        })
        .catch(() => {});
    }
  }, [lang]);

  // Field-level fallbacks
  const display = content || fallbackContent;

  const sectionName =
    display?.contanct_section_name ||
    fallbackContent?.contanct_section_name;

  const title =
    display?.contact_section_title ||
    fallbackContent?.contact_section_title;

  const linkUrl =
    display?.contact_link_url ||
    fallbackContent?.contact_link_url ||
    "#";

  const linkText =
    display?.contact_link_text ||
    fallbackContent?.contact_link_text ||
    "";

  const imageUrl = content?.contact_image?.url
    ? `${Base_URL}${content.contact_image.url}`
    : fallbackContent?.contact_image?.url
    ? `${Base_URL}${fallbackContent.contact_image.url}`
    : null;

  return (
    <div
      className="padding-x-40 padding-y-80 custom-lg-flex"
      style={{ backgroundColor: "rgba(188, 226, 245, 1)" }}
    >
      {/* Left block */}
      <div className="col-lg-6 contact-wrapper">
        <div>
          <div className="section-name-wrapper">
            <div className="section-name-dot"></div>
            <span className="section-name">{sectionName}</span>
          </div>
          <h2 className="size-h3 col-xl-9 pt-2.5 text-dark-blue-color">
            {title}
          </h2>
        </div>
        <a className="text-link" href={linkUrl}>
          {linkText}
        </a>
      </div>

      {/* Right block */}
      <div className="col-lg-6 overflow-hidden rounded-[5px] pt-[40px] md:pt-0">
        {imageUrl && (
          <img
            className="w-full rounded-[5px] hover:scale-110 transition-transform duration-300"
            src={imageUrl}
            alt={title || "contact"}
          />
        )}
      </div>
    </div>
  );
}